module.exports = __webpack_public_path__ + "media/site_templates/www.hirecarpenters.com.au/images/splash-ac29b13e14a9a7045a4d5560bef53aa7.jpg";